export const NEWLY_MANAGED_MESSAGE_ID = 'newly-managed';
export const INACTIVE_MIGRATION_MESSAGE_ID =
  'inactive-migration-onboarding-required';
